import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';
import { editMyDetailsRoutes } from '../../../edit-my-details/routing/route-locales/edit-my-details-routes';
import { lmwAuthLazyLoadedState } from '../../../auth-process/common/routing/route-locales/app-routes';
import { signInLazyLoaded } from '../../../auth-process/sign-in/routing/route-locales/sign-in-routes';
import { registrationLazyLoaded } from '../../../auth-process/registration/routing/route-locales/registration-routes';
import { StrapiService } from '@nx/strapi';
import { publishReplay, refCount, take } from 'rxjs/operators';
import { HeaderCms } from '../../interfaces/header-cms.interface';
import { Observable } from 'rxjs';
import { environment } from 'apps/learn-my-way/src/environments/environment';

@Component({
  selector: 'lmw-base-header-base',
  templateUrl: './header-base.component.html'
})
export class HeaderBaseComponent implements OnInit {

  public browseAllSubjectsLink: string = lmwBaseRoutes.browseSubjectsStatePath;
  public helpLink: string = lmwBaseRoutes.helpStatePath;
  public myLearningLink: string = lmwBaseRoutes.myLearningHomeStatePath;
  public editMyDetailsLinkPath: string = editMyDetailsRoutes.editMyDetailsStatePath;
  public currentRoute: string;
  public headerCms: Observable<HeaderCms>;
  public hideUserLinks = !environment.loadAuth;
  public signInLinkPath = `/${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}`;
  public registrationLinkPath = `/${lmwAuthLazyLoadedState.path}/${registrationLazyLoaded.path}`;
  public userLoggedIn = false;
  public isAreaNeedingSignIn = false;
  public language: string = environment.language;

  constructor(private location: Location, private router: Router, private strapiService: StrapiService) {}

  ngOnInit(): void {
    this.currentRoute = this.location.path();
    this.router.events.subscribe(() => {
      this.currentRoute = this.location.path();
    });
    this.headerCms = this.strapiService.get('header?populate=*').pipe(publishReplay(1),refCount());
  }
}
